import React from 'react';
import Chart from "react-apexcharts";
import { numberWithSpaces } from '../../../../helpers/index';
import { useLingui } from '@lingui/react';
import { IGraphHeatmapData } from '../../../../interfaces/types';
import { t } from '@lingui/macro';
 
const skGraph = require("apexcharts/dist/locales/sk")
const csGraph = require("apexcharts/dist/locales/cs")
const deGraph = require("apexcharts/dist/locales/de")
const enGraph = require("apexcharts/dist/locales/en")

interface IProps {
    graphData: IGraphHeatmapData,
    graphTitle: string
}

const HeatmapGraph = ({graphData, graphTitle}: IProps) => {
    const lingui = useLingui()

    if (!graphData?.series?.length) {
        return null
    }

    console.log(graphData.series)

    return (
        <Chart 
            options={{
                legend: {
                    show: false,
                    position: 'bottom'
                },
                chart: {
                    toolbar: {
                        show: true,
                        tools: {
                            download: '<span><svg class="sico wh16"><use xlink:href="/assets/layout/icons.svg#s_save"></use></svg>'
                        }
                    },
                    locales: [skGraph, csGraph, enGraph, deGraph],
                    defaultLocale: lingui.i18n.locale
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ['#000000']
                    }
                },
                colors: ["#008FFB"],
                // colors: getRandomColors(graphData.categories.length),
                stroke: {
                    show: false
                },
                xaxis: {
                    title: {
                        text: t`Hodiny`
                    },
                    type: 'category',
                    labels: {
                        formatter: (value: string) => {
                            return value;
                        },
                        rotateAlways: false,
                    },
                    tickAmount: 8,
                },
                yaxis: {
                    title: {
                        text: t`Dni`
                    },
                    labels: {
                        formatter: (val) => {
                            return numberWithSpaces(val)
                        }
                    },
                },
                tooltip: {
                    y: graphData.series.map(s => {
                            return {
                                title: {
                                    formatter: function (val) {
                                        return val
                                    }
                                },
                                formatter: (val) => {
                                    return numberWithSpaces(val)
                                }
                            }
                        }),
                    // x: {
                    //     formatter: (val) => {
                    //         return moment(val).local().format('HH:mm')
                    //     }
                    // }
                },
                
                // labels: graphData.categories
            }} 
            series={graphData.series as any} 
            type="heatmap" 
            height={450} 
        />
    )
};

export default HeatmapGraph